import { IconShieldLock } from '@tabler/icons';

const icons = {
  IconShieldLock
};

const adminMenu = {
  id: 'adminMenu',
  title: 'Administrador',
  type: 'group',
  children: [
    {
      id: 'admin-resumen',
      title: 'Resumen',
      type: 'item',
      url: '/admin/resumen',
      icon: icons.IconShieldLock,
      breadcrumbs: false
    },
    {
      id: 'admin-dispositivos',
      title: 'Dispositivos',
      type: 'item',
      url: '/admin/dispositivos',
      icon: icons.IconShieldLock,
      breadcrumbs: false
    },
    {
      id: 'admin-reportes',
      title: 'Reportes',
      type: 'item',
      url: '/admin/reportes',
      icon: icons.IconShieldLock,
      breadcrumbs: false
    },
    {
      id: 'admin-usuarios',
      title: 'Usuarios',
      type: 'item',
      url: '/admin/usuarios',
      icon: icons.IconShieldLock,
      breadcrumbs: false
    }
    // Herramientas IoT deshabilitada temporalmente (la pantalla llama a endpoints que no existen en la API).
    // Para reactivar: descomentar este item y la ruta/import en routes/MainRoutes.js.
    // ,{
    //   id: 'admin-herramientas-iot',
    //   title: 'Herramientas IoT',
    //   type: 'item',
    //   url: '/admin/herramientas-iot',
    //   icon: icons.IconShieldLock,
    //   breadcrumbs: false
    // }
  ]
};

export default adminMenu;
